import style from './EmptyContent.module.scss'

interface IProps {
    title: string
    action?: {
        title: string
        callback: () => void
    }
}

export const EmptyContent = (props: IProps) => {
    const { title, action } = props
    return (
        <div className={style.container}>
            <h3>{title}</h3>
            {action && <button onClick={action.callback}>{action.title}</button>}
        </div>
    )
}
